import { Admin } from './../../../models/admin';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { PNotifyService } from '../../../services/pnotify.service';

@Component({
  selector: 'app-admin-add',
  templateUrl: './admin-add.component.html',
  styleUrls: ['./admin-add.component.css']
})
export class AdminAddComponent implements OnInit {

  admin: Admin;
  passwordConfirm_ = '';
  reservedUsernames: string[];
  pnotify = undefined;
  // ----- Start DatePicker -----------
  dateTimeFilter = (d: Date): boolean => {
    return true;
  }
  // ----- End DatePicker -----------

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    pnotifyService: PNotifyService
  ) {
    this.admin = new Admin();
    this.reservedUsernames = [];
    this.http.get(
      '/api/admin/reservedUsernames/0'
    ).subscribe((usernames: any[]) => {
      for (let i = 0; i < usernames.length; i++) {
        this.reservedUsernames.push(usernames[i].username);
      }
    });
    this.pnotify = pnotifyService.getPNotify();
  }

  ngOnInit() {
  }

  onUsernameChange() {
    this.admin.username = this.admin.username.replace(/\s/g, '');
  }

  onSubmit(): void {
    this.http.post(
      '/api/admin/0',
      { admin: this.admin }
    ).subscribe(
      (admin: Admin) => {
        this.admin = admin;
        this.router.navigate(['/admin/view', this.admin.id]);
      },
      (error) => {
        this.pnotify.error({
          title: 'Erreur',
          text: 'Une erreur est survenue !',
          stack: {
            firstpos1: 70, firstpos2: 10,
            modal: true,
            overlay_close: true
          },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [
                {
                  text: 'Ok',
                  addClass: 'btn btn-chico',
                  click: notice => {
                    notice.close();
                  }
                }
              ]
            }
          }
        });
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/admin-add/admin-add.component.ts